import { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getBusinessDashboard } from "../store/slices/businessOwnerSlice";
import { showApiError } from "../utils/toast";

export const useBusinessDashboard = () => {
  const dispatch = useDispatch();
  const { dashboard, dashboardLoading, dashboardError } = useSelector(
    (state) => state.businessOwner
  );

  const [filter, setFilter] = useState("TODAY");
  const [customDates, setCustomDates] = useState({ from: "", to: "" });

  // Initial load on mount only
  useEffect(() => {
    fetchDashboard("TODAY");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchDashboard = useCallback(async (currentFilter, currentDates) => {
    const token = localStorage.getItem("authToken");
    
    if (!token) {
      showApiError(null, "Authentication required. Please login again.");
      return;
    }
    
    try {
      const filterToUse = currentFilter || filter;
      const datesToUse = currentDates || customDates;
      
      const params = {
        filter: filterToUse,
      };
      
      if (filterToUse === "CUSTOM" && datesToUse.from && datesToUse.to) {
        params.from = datesToUse.from;
        params.to = datesToUse.to;
      }
      
      await dispatch(getBusinessDashboard(params));
    } catch (error) {
      console.error("Dashboard fetch error:", error);
      showApiError(null, "Failed to load dashboard data");
    }
  }, [dispatch, filter, customDates]);

  const updateFilter = useCallback((newFilter) => {
    setFilter(newFilter);
  }, []);

  const updateCustomDates = useCallback((dates) => {
    setCustomDates(dates);
  }, []);

  const onApplyFilter = useCallback(() => {
    fetchDashboard(filter, customDates);
  }, [fetchDashboard, filter, customDates]);

  const refreshDashboard = useCallback(() => {
    fetchDashboard(filter, customDates);
  }, [fetchDashboard, filter, customDates]);

  return {
    dashboard,
    loading: dashboardLoading,
    error: dashboardError,
    filter,
    customDates,
    updateFilter,
    updateCustomDates,
    onApplyFilter,
    refreshDashboard,
  };
};